import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
//import data from '../../assets/data/sales-transactions';
//import Datatable from '../common/datatable';
import VerDetailsOrderDatatable from '../common/ver-details-order-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
//import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import Moment from 'moment';
import Select from 'react-select';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';

// ─── estilo visual copiado de customer-profile/:id (solo la tabla principal;
// VerOrderDatatable es compartido con otras 3 vistas, no se toca) ───────────

const PURCHASE_STATUS_MAP = {
    COMPLETADO: { label: "Completado", bg: "#d4edda", color: "#155724" },
    PENDIENTE: { label: "Pendiente", bg: "#fff3cd", color: "#856404" },
    CANCELADO: { label: "Cancelado", bg: "#f8d7da", color: "#721c24" },
    PAGADO: { label: "Pagado", bg: "#cce5ff", color: "#004085" },
    PROCESADO: { label: "Procesado", bg: "#e2d9f3", color: "#432874" },
};

function PurchaseBadge({ status }) {
    const s = PURCHASE_STATUS_MAP[status] || { label: status || "—", bg: "#e9ecef", color: "#495057" };
    return (
        <span style={{ background: s.bg, color: s.color, borderRadius: 10, padding: "2px 9px", fontSize: 12, fontWeight: 600 }}>
            {s.label}
        </span>
    );
}

function fmtMoney(val) {
    if (val === null || val === undefined || val === "") return "—";
    return "S/ " + parseFloat(val).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function fmtDate(val) {
    if (!val) return "—";
    return Moment(val).format("DD MMM YYYY");
}

export class VerOrderList extends Component {
    constructor(props) {
        super(props);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.handlerAcept = this.handlerAcept.bind(this);
        this.handlerCancel = this.handlerCancel.bind(this);
        this.handlerRemove = this.handlerRemove.bind(this);
        this.handlerDetails = this.handlerDetails.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            open: false,
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
            detailResults: [],
            client: '',
            date: '',
            hour: '',
            id_order: null,
            total_order: null,
            address: '',
            district: '',
            interior: '',
            url_google: '',
            cash: 0,
            delivery: 0,
            discount: 0,
            selectedOption: null,
            year: 0,
            month: 0,
            ordersPage: 1,
            ordersSort: { key: null, dir: 'asc' },
        };
        this.handleOrdersSort = this.handleOrdersSort.bind(this);
    }

    handleOrdersSort(key) {
        this.setState((prev) => ({
            ordersSort: nextSort(prev.ordersSort, key),
            ordersPage: 1,
        }));
    }

    onChangeFilter(e) {

        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          //Los botones de acciones se pintan despues
          columns.splice(columns.length);
          //columns.splice(columns.length - 1);
    
          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });
          this.setState({
            results: rows
        }, function () {
            this.renderResults(this.state.results.length);
        });
          
        }



        e.preventDefault();
      }

    componentWillMount() {
        this.getDataOrders();
        this.getDataCateg();
    }

    getDataCateg(){
        var user = AuthService.getCurrentUser();
        ApiService.getDataReportsMonthsAndYearsPending(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    let items_parent = [];
                    this.setState({ dataListCateg: res.data });

                    for (let i = 0; i < res.data.length; i++) {
                        let array_data = {};
                        array_data['value'] = i;
                        array_data['label'] = res.data[i]['year2'] + '-' + res.data[i]['month2'];
                        items_parent.push(array_data);
                    }
                    this.setState({ dataCateg: items_parent });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    getDataOrders(){
        var user = AuthService.getCurrentUser();
        ApiService.getOrders(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        var start_time = row.hour_programmed_start?row.hour_programmed_start.toString():'';
                        var end_time = row.hour_programmed_end?row.hour_programmed_end.toString():'';
                        var nameAmbassador = row.Referred && row.Referred.name ? row.Referred.name : '-';
                        var lastnameAmbassador = row.Referred && row.Referred.last_name ? row.Referred.last_name : '-';
                        var totalOrder = row.totalOrder;
                        return { 
                            Id: row.id, 
                            id_user: row.id_user,
                            Usuario : row.User.name + ' ' + row.User.last_name, 
                            Embajador : nameAmbassador + ' ' + lastnameAmbassador, 
                            Fecha: row.date_programmed,
                            Hora: start_time && end_time?start_time.slice(0, -3) + ' - '+ end_time.slice(0, -3):'',
                            Estado : row.status, 
                            address: row.address,
                            Pago: row.deferred_pay,
                            Delivery: row.delivery?row.delivery:"0.00",
                            Total : totalOrder,
                            data: row,
                        }
                     })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    getDataOrdersFilter(month, year){
        var user = AuthService.getCurrentUser();
        

        ApiService.getOrdersFilter(user.token,month,year).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        var start_time = row.hour_programmed_start?row.hour_programmed_start.toString():'';
                        var end_time = row.hour_programmed_end?row.hour_programmed_end.toString():'';
                        var nameAmbassador = row.Referred && row.Referred.name ? row.Referred.name : '-';
                        var lastnameAmbassador = row.Referred && row.Referred.last_name ? row.Referred.last_name : '-';
                        var totalOrder = row.totalOrder;
                        return { 
                            Id: row.id, 
                            id_user: row.id_user,
                            Usuario : row.User.name + ' ' + row.User.last_name, 
                            Embajador : nameAmbassador + ' ' + lastnameAmbassador, 
                            Teléfono: row.phoneAmbassador,
                            Fecha: row.date_programmed,
                            Hora: start_time && end_time?start_time.slice(0, -3) + ' - '+ end_time.slice(0, -3):'',
                            Estado : row.status, 
                            Pago : row.deferred_pay, 
                            address: row.address,
                            Delivery: row.delivery?row.delivery:"0.00",
                            Total : totalOrder,
                            data: row,
                        }
                     })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0',
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>
                    {from}–{to} de {total}
                </span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>
                        {page} / {totalPages}
                    </span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults(){
        const { results, ordersPage, ordersSort } = this.state;
        if (results.length === 0) return 'No hay datos.';

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, ordersSort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const page = Math.min(ordersPage, totalPages);
        const paginated = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

        const headers = [
            { label: '#', key: 'Id' },
            { label: 'Usuario', key: 'Usuario' },
            { label: 'Embajador', key: 'Embajador' },
            { label: 'Fecha', key: 'Fecha' },
            { label: 'Hora', key: 'Hora' },
            { label: 'Pago', key: 'Pago' },
            { label: 'Delivery', key: 'Delivery' },
            { label: 'Total', key: 'Total' },
            { label: 'Estado', key: 'Estado' },
            'Acción',
        ];

        return (
            <div className='card' style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                <div className='card-body' style={{ padding: 0 }}>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                            <thead>
                                <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                    {headers.map((h) => (
                                        <SortableTh
                                            key={typeof h === 'object' ? h.key : h}
                                            header={h}
                                            sort={ordersSort}
                                            onSort={this.handleOrdersSort}
                                        />
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {paginated.map((item) => {
                                    const row = { original: item };
                                    return (
                                        <tr
                                            key={item.Id}
                                            style={{ borderBottom: '1px solid #f4f4f4' }}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = '#f0faf4')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                        >
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#27ae60', fontSize: 12, fontWeight: 600 }}>
                                                #{item.Id}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                                <a
                                                    href={`${process.env.PUBLIC_URL}/customer-profile/${item.id_user}`}
                                                    style={{ color: '#007bff', fontWeight: 500 }}
                                                >
                                                    {item.Usuario}
                                                </a>
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                                {item.Embajador}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                                {fmtDate(item.Fecha)}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                                {item.Hora || '—'}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                                {item.Pago || '—'}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                                {fmtMoney(item.Delivery)}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700 }}>
                                                {fmtMoney(item.Total)}
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                                <PurchaseBadge status={item.Estado} />
                                            </td>
                                            <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                                {item.Estado === 'PROCESADO' ? (
                                                    <div style={{ display: 'flex' }}>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handlerDetails(row); }} title="Ver detalle">
                                                            <i className="fa fa-eye" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(48 159 212)' }}></i>
                                                        </a>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handlerAcept(row); }} title="Aceptar">
                                                            <i className="fa fa-check-circle" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(40, 167, 69)' }}></i>
                                                        </a>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handlerCancel(row); }} title="Rechazar">
                                                            <i className="fa fa-times-circle" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(251 15 15)' }}></i>
                                                        </a>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handlerRemove(row); }} title="Eliminar">
                                                            <i className="fa fa-trash" style={{ width: 30, fontSize: 16, padding: 6, color: '#e4566e' }}></i>
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <div style={{ display: 'flex' }}>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handlerDetails(row); }} title="Ver detalle">
                                                            <i className="fa fa-eye" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(48 159 212)' }}></i>
                                                        </a>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handlerRemove(row); }} title="Eliminar">
                                                            <i className="fa fa-trash" style={{ width: 30, fontSize: 16, padding: 6, color: '#e4566e' }}></i>
                                                        </a>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    {this.renderPagination(results.length, page, PAGE_SIZE, (p) => this.setState({ ordersPage: p }))}
                </div>
            </div>
        );
    }

    renderDetailResults(){
		return this.state.detailResults.length === 0 
			? ''
			: <VerDetailsOrderDatatable
            multiSelectOption={false}
            myData={this.state.detailResults}
            pageSize={this.state.detailResults.length+1}
            pagination={true}
            class="-striped -highlight"
        />
    }   

    showImage(results){
        // Aplicamos un fix si no devuelve una imagen 
        let url_image = `${process.env.REACT_APP_URL_FILES}/images/products/`;
            for (let i = 0; i < results.length; i++){
                results[i]['imagen'] = <img src={url_image + (results[i]['Product']['url']?results[i]['Product']['url']:(results[i]['Product']['logo']?results[i]['Product']['logo']:''))} style={{width:50,height:50}}/>;
            }
            return results;
        }

    handlerDetails(data_row) {
        var user = AuthService.getCurrentUser();
        ApiService.getOrderDetails(user.token,data_row.original.Id).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = this.showImage(res.data.Purchases_detail).map(function(row) {
                        return { 
                          id: row.id, 
                          Imagen: row.imagen, 
                          Nombre : row.Product.name, 
                          Precio : row.price, 
                          Cantidad : row.quantity, 
                          Total : row.total,
                        }
                     })
                    
                     var type_address = data_row.original.data.type_address?data_row.original.data.type_address:'';
                     var address = data_row.original.data.address?data_row.original.data.address:'';
                     var number = data_row.original.data.number?data_row.original.data.number:'';
                     var start_time = res.data.hour_programmed_start?res.data.hour_programmed_start.toString():'';
                     var end_time = res.data.hour_programmed_end?res.data.hour_programmed_end.toString():'';

                    this.setState({ detailResults:items });
                    this.setState({ client: data_row.original.Usuario });
                    this.setState({ date: res.data.date_programmed?res.data.date_programmed:'' });
                    this.setState({ hour: start_time && end_time?start_time.slice(0, -3) + ' - ' + end_time.slice(0, -3):'' });
                    this.setState({ id_order: data_row.original.Id });
                    this.setState({ total_order: data_row.original.Total });
                    this.setState({ address: type_address+' '+address+' '+number });
                    this.setState({ cash: res.data.cash?parseInt(res.data.cash, 10):0 });
                    this.setState({ district: data_row.original.data.district?data_row.original.data.district:'' });
                    this.setState({ interior: data_row.original.data.interior?data_row.original.data.interior:'' });
                    this.setState({ url_google: data_row.original.data.url_google?data_row.original.data.url_google:'' });
                    this.setState({ delivery: res.data.delivery?res.data.delivery:"0.00" });
                    this.setState({ discount: res.data.discount?res.data.discount:"0.00" });
                    
                    this.renderDetailResults();
                    this.onOpenModal();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    handlerAcept(data_row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea aceptar la orden nro '+ data_row.original.Id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33', 
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if(result.value){
                
                var user = AuthService.getCurrentUser();
                let data = {
                    'idPurchase': data_row.original.Id,
                    'id_user': data_row.original.id_user,
                }
                ApiService.postAceptPurchase(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            Swal.fire("Hecho!", "Orden Aceptada!", "success");
                            //toast.success("Orden Aceptada!");
                            this.setState({results: []});
                            this.getDataOrders();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );




           }
         })
        //this.props.history.push("/edit-user/"+data_row.original.id);
        //window.location.reload();
    }

    handlerCancel(data_row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea cancelar la orden nro '+ data_row.original.Id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33', 
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if(result.value){
                
                var user = AuthService.getCurrentUser();
                let data = {
                    'idPurchase': data_row.original.Id,
                    'id_user': data_row.original.id_user,
                }
                ApiService.postCancelPurchase(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            Swal.fire("Hecho!", "Orden Cancelada!", "success");
                            this.setState({results: []});
                            this.getDataOrders();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );




           }
         })
        //this.props.history.push("/edit-user/"+data_row.original.id);
        //window.location.reload();
    }

    handlerRemove(data_row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea eliminar la orden nro '+ data_row.original.Id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33', 
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if(result.value){
                
                var user = AuthService.getCurrentUser();
                let data = {
                    'idPurchase': data_row.original.Id,
                    'id_user': data_row.original.id_user,
                }
                ApiService.postRemovePurchase(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            Swal.fire("Hecho!", "Orden eliminada!", "success");
                            this.setState({results: []});
                            this.getDataOrders();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );




           }
         })
        
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    componentWillReceiveProps(){
        this.getDataOrders()
    }

    handleChange = selectedOption => {
        let array_categ = [];
        array_categ = this.state.dataListCateg;

        //let optionSelected = null;
        //optionSelected = array_categ[selectedOption.value]['year2'] + ' - ' + array_categ[selectedOption.value]['month2'];
        
        this.setState({ 
            month: array_categ[selectedOption.value]['month2'],
            year: array_categ[selectedOption.value]['year2']
            //dataSubCateg: array_sub_categ 
        });
        
        this.setState(
          { selectedOption },
        );
        this.getDataOrdersFilter(array_categ[selectedOption.value]['month2'],array_categ[selectedOption.value]['year2'] )
    };

    render() {
        const { open, selectedOption } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Pedidos recibidos" parent="Sales" />

                <div className="container-fluid">
                    <div style={{
                        display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center',
                        background: '#fff', border: '1px solid #ebebeb', borderRadius: 10,
                        padding: 14, marginTop: 16, marginBottom: 16,
                    }}>
                        <div style={{ flex: '0 1 260px', minWidth: 220 }}>
                            <Select
                                value={selectedOption}
                                onChange={this.handleChange}
                                options={this.state.dataCateg}
                                placeholder="Filtrar por mes"
                            />
                        </div>
                        <div style={{ flex: '1 1 260px', minWidth: 220 }}>
                            <input
                                placeholder="Escriba para filtrar todas las columnas"
                                name="filter"
                                type="text"
                                autoComplete="off"
                                onInput={this.onChangeFilter}
                                style={{
                                    width: '100%', borderRadius: 8, border: '1px solid #ddd',
                                    padding: '8px 12px', fontSize: 14, margin: 0,
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div id="batchDelete" className="transactions">

                                        {this.renderResults()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={open} onClose={this.onCloseModal} >

                <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">Orden n° {this.state.id_order}</h5>
                </div>
                <div className="modal-body">
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Usuario:</label>
                        {this.state.client}
                    </div>
                    
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Distrito:</label>
                        {this.state.district}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Dirección:</label>
                        {this.state.address}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Interior:</label>
                        {this.state.interior}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Url Google:</label>
                        <a href={ this.state.url_google } target="blank">Ver ubicación</a>
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Fecha:</label>
                        {this.state.date}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Hora:</label>
                        {this.state.hour}
                    </div>
                    {
                    this.state.cash>0?
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Crédito:</label>
                        {fmtMoney(this.state.cash)}
                    </div>
                    :''
                    }
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Delivery:</label>
                        {fmtMoney(this.state.delivery)}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Total:</label>
                        {fmtMoney(this.state.total_order)}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Descuento:</label>
                        {fmtMoney(this.state.discount)}
                    </div>
                    <div>
                    <label style={{fontWeight: 'bold'}}>Detalle:</label>
                    {this.renderDetailResults()}
                    </div>
                </div>
                <div className="modal-footer">
                </div>
                </Modal>
            </Fragment>
        )
    }
}

export default VerOrderList
